import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { RolesPermisosService } from '../roles-y-permisos.service';

@Injectable({ providedIn: 'root' })
export class ActualizarRolResolver implements Resolve<any> {

    constructor(private _rolesPermisosService: RolesPermisosService){}

    resolve(route: ActivatedRouteSnapshot): Observable<any> {

        const rol_uuid =route.paramMap.get('rol_uuid');
        const rol_id =isNaN(parseInt(rol_uuid)) ? 0 : parseInt(rol_uuid);
        
        return forkJoin([
                        this._rolesPermisosService.getRol(rol_id)
                    ]);
    }
}